<div class="main-content1">
  <div class="category-page-wrapper">
    <div class="layout">
      <!-- LEFT SIDEBAR BACKDROP & DRAWER FOR MOBILE -->
      <div class="sidebar-backdrop" *ngIf="mobileFilterOpen" (click)="mobileFilterOpen = false"></div>
      <div class="sidebar" [class.mobile-open]="mobileFilterOpen">
        <div class="sidebar-header">
          <div class="sidebar-header-left">
            <h3>Filter</h3>
            <button class="clear-btn" (click)="clearAllFilters()">
              Clear all
            </button>
          </div>
          <button class="mobile-close-btn" (click)="mobileFilterOpen = false" aria-label="Close filters">
            ✕
          </button>
        </div>

        <div class="sidebar-section">
          <!-- REQUIRED DATE RANGE -->
          <div class="accordion-item">
            <div class="accordion-header" (click)="toggleAccordion('dateRange')">
              <span>REQUIRED DATE RANGE</span>
              <span class="arrow" [class.open]="openSectionStates['dateRange']">▾</span>
            </div>

            <div class="accordion-content" *ngIf="openSectionStates['dateRange']">
              <div class="date-filter-box">
                <!-- START DATE -->
                <div class="date-cell">
                  <div class="date-label">From</div>
                  <div class="value" [class.active]="pendingStartDisplay" (click)="openFromCalendar($event)">
                    {{ pendingStartDisplay || "Start Date" }}
                  </div>
                  <div class="calendar-dropdown" *ngIf="showCalendarFrom" (click)="$event.stopPropagation()">
                    <div class="calendar-header">
                      <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                      <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                      <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                    </div>
                    <div class="calendar-weekdays">
                      <span *ngFor="let d of weekdays">{{ d }}</span>
                    </div>
                    <div class="calendar-grid">
                      <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                        [class.is-today]="day.isToday" [class.is-past]="day.isPast" [class.selected]="day.selected"
                        (click)="!day.isPast && selectStartDay(day)">
                        {{ day.date }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- END DATE -->
                <div class="date-cell">
                  <div class="date-label">To</div>
                  <div class="value" [class.active]="pendingEndDisplay" (click)="openToCalendar($event)">
                    {{ pendingEndDisplay || "End Date" }}
                  </div>
                  <div class="calendar-dropdown" style="left: 200px" *ngIf="showCalendarTo"
                    (click)="$event.stopPropagation()">
                    <div class="calendar-header">
                      <span class="chevron" (click)="prevMonth()">&lsaquo;</span>
                      <h3>{{ currentMonthName }} {{ currentYear }}</h3>
                      <span class="chevron" (click)="nextMonth()">&rsaquo;</span>
                    </div>
                    <div class="calendar-weekdays">
                      <span *ngFor="let d of weekdays">{{ d }}</span>
                    </div>
                    <div class="calendar-grid">
                      <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
                        [class.is-today]="day.isToday" [class.is-past]="day.isPast"
                        [class.selected]="isEndSelected(day)" (click)="!day.isPast && selectEndDay(day)">
                        {{ day.date }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- EMIRATES -->
          <div class="accordion-item">
            <div class="accordion-header" (click)="toggleAccordion('emirates')">
              <span>EMIRATES</span>
              <span class="arrow" [class.open]="openSectionStates['emirates']">▾</span>
            </div>
            <div class="accordion-content" *ngIf="openSectionStates['emirates']">
              <label *ngFor="let emirate of emirates">
                <input type="radio" name="emirate" [value]="emirate" [(ngModel)]="pendingEmirate" />
                {{ emirate }}
              </label>
            </div>
          </div>

          <!-- FUEL -->
          <div class="accordion-item" *ngIf="fuels.length || isLoading">
            <div class="accordion-header" (click)="fuels.length && toggleAccordion('fuel')">
              <div class="header-left">
                <span>FUEL</span>
              </div>
              <div class="header-right">
                <span class="arrow" *ngIf="fuels.length" [class.open]="openSectionStates['fuel']">▾</span>
              </div>
            </div>
            <div class="accordion-content" *ngIf="openSectionStates['fuel'] || (isLoading && !fuels.length)">
              <ng-container *ngIf="!isLoading; else sidebarSkeleton">
                <label *ngFor="let fuel of fuels.slice(0, 8)">
                  <input type="checkbox" [value]="fuel" (change)="toggleSelection(fuel, 'fuel')"
                    [checked]="pendingFuels.includes(fuel)" />
                  <span>{{ fuel }}</span>
                  <span class="count">({{ getOptionCount(fuel, 'fuel') }})</span>
                </label>
                <div class="more-link" *ngIf="fuels.length > 8"
                  (click)="$event.stopPropagation(); openFilterModal('fuel')">
                  + {{ fuels.length - 8 }} more
                </div>
              </ng-container>
            </div>
          </div>

          <!-- MAKE -->
          <div class="accordion-item" *ngIf="makes.length || isLoading">
            <div class="accordion-header" (click)="makes.length && toggleAccordion('make')">
              <div class="header-left">
                <span>MAKE</span>
              </div>
              <div class="header-right">
                <span class="arrow" *ngIf="makes.length" [class.open]="openSectionStates['make']">▾</span>
              </div>
            </div>
            <div class="accordion-content" *ngIf="openSectionStates['make'] || (isLoading && !makes.length)">
              <ng-container *ngIf="!isLoading; else sidebarSkeleton">
                <label *ngFor="let make of makes.slice(0, 8)">
                  <input type="checkbox" [value]="make" (change)="toggleSelection(make, 'make')"
                    [checked]="pendingMakes.includes(make)" />
                  <span>{{ make }}</span>
                  <span class="count">({{ getOptionCount(make, 'make') }})</span>
                </label>
                <div class="more-link" *ngIf="makes.length > 8"
                  (click)="$event.stopPropagation(); openFilterModal('make')">
                  + {{ makes.length - 8 }} more
                </div>
              </ng-container>
            </div>
          </div>

          <!-- YEAR OF MANUFACTURE -->
          <div class="accordion-item" *ngIf="years.length || isLoading">
            <div class="accordion-header" (click)="years.length && toggleAccordion('year')">
              <span>YEAR OF MANUFACTURE</span>
              <span class="arrow" *ngIf="years.length" [class.open]="openSectionStates['year']">▾</span>
            </div>
            <div class="accordion-content" *ngIf="openSectionStates['year'] || (isLoading && !years.length)">
              <ng-container *ngIf="!isLoading; else sidebarSkeleton">
                <div class="year-input-box">
                  <div class="year-dropdown" (click)="$event.stopPropagation()">
                    <input type="text" placeholder="From year" [(ngModel)]="searchFrom" readonly
                      (focus)="fromOpen = true; toOpen = false" />
                    <div class="dropdown-panel" *ngIf="fromOpen">
                      <div class="year-list">
                        <div class="option" *ngFor="let y of filteredFromYears"
                          [class.disabled]="yearToInput && y > yearToInput"
                          (click)="(!yearToInput || y <= yearToInput) && selectFromYear(y)">
                          {{ y }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="year-dropdown" (click)="$event.stopPropagation()">
                    <input type="text" placeholder="To year" [(ngModel)]="searchTo" readonly
                      (focus)="toOpen = true; fromOpen = false" />
                    <div class="dropdown-panel" *ngIf="toOpen">
                      <div class="year-list">
                        <div class="option" *ngFor="let y of filteredToYears"
                          [class.disabled]="yearFromInput && y < yearFromInput"
                          (click)="(!yearFromInput || y >= yearFromInput) && selectToYear(y)">
                          {{ y }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="available-years-section" *ngIf="validYearRange.length">
                  <p class="section-label">Available years</p>
                  <div class="year-toggle-container">
                    <button class="year-toggle" *ngFor="let y of validYearRange"
                      [class.selected]="pendingYears.includes(y)" (click)="toggleYearChip(y)">
                      {{ y }}
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- SKELETON REUSABLE TEMPLATE -->
          <ng-template #sidebarSkeleton>
            <div class="skeleton skeleton-sidebar-item"></div>
            <div class="skeleton skeleton-sidebar-item"></div>
            <div class="skeleton skeleton-sidebar-item"></div>
          </ng-template>
        </div>

        <button class="update-btn" (click)="updateFilters()">Update</button>
      </div>

      <!-- RIGHT CONTENT -->
      <main class="content">
        <div class="title-row">
          <div class="title-left">
            <button class="back-btn" (click)="goBack()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
            </button>
            <h2 class="title">{{ categoryName }}</h2>
          </div>
          <div class="title-actions">
            <!-- Mobile Filter Trigger Button -->
            <button class="mobile-filter-trigger-btn" (click)="mobileFilterOpen = true">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="4" y1="21" x2="4" y2="14"></line>
                <line x1="4" y1="10" x2="4" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12" y2="3"></line>
                <line x1="20" y1="21" x2="20" y2="16"></line>
                <line x1="20" y1="12" x2="20" y2="3"></line>
                <line x1="1" y1="14" x2="7" y2="14"></line>
                <line x1="9" y1="8" x2="15" y2="8"></line>
                <line x1="17" y1="16" x2="23" y2="16"></line>
              </svg>
              <span>Filters</span>
              <span class="filter-count-badge" *ngIf="getActiveFilterCount()">{{ getActiveFilterCount() }}</span>
            </button>

            <button *ngIf="showCompare" class="compare-toggle-btn" [class.active]="isCompareMode"
              (click)="isCompareMode ? exitCompareMode() : isCompareMode = true">
              <span *ngIf="!isCompareMode">Compare</span>
              <span *ngIf="isCompareMode">Exit</span>
            </button>
          </div>
        </div>

        <!-- COMPARE HELPER BANNER with live counter -->
        <div class="compare-helper-banner" *ngIf="showCompare && isCompareMode"
          [class.limit-reached]="compareList.length >= 3">
          <span class="info-icon">
            <svg *ngIf="compareList.length < 3" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <circle cx="7.5" cy="7.5" r="6.5" stroke="currentColor" stroke-width="1.5" />
              <path d="M7.5 6.5V10.5M7.5 4.5V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <svg *ngIf="compareList.length >= 3" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path
                d="M7.5 1L9.18 5.18L13.5 5.64L10.35 8.52L11.27 13L7.5 10.77L3.73 13L4.65 8.52L1.5 5.64L5.82 5.18L7.5 1Z"
                fill="currentColor" />
            </svg>
          </span>
          <span class="banner-main-text">
            <span *ngIf="compareList.length < 3">Select up to 3 equipment listings to compare</span>
            <span *ngIf="compareList.length >= 3">Maximum reached — tap Compare to see results</span>
          </span>
          <!-- Live selection counter with dot indicators -->
          <span class="compare-counter">
            <span class="counter-dots">
              <span class="dot" [class.filled]="compareList.length >= 1"></span>
              <span class="dot" [class.filled]="compareList.length >= 2"></span>
              <span class="dot" [class.filled]="compareList.length >= 3"></span>
            </span>
            {{ compareList.length }}/3
          </span>
        </div>

        <!-- ACTIVE FILTER PEBBLES -->
        <div class="selected-filters" *ngIf="
            searchText ||
            selectedEmirate ||
            selectedFuels.length ||
            selectedMakes.length ||
            selectedYears.length ||
            selectedSubcategories.length ||
            searchStartDisplay
          ">
          <div class="filter-chip" *ngIf="searchText">
            <span>Search: {{ searchText }}</span>
            <span class="close" (click)="removeFilter('text')">×</span>
          </div>
          <div class="filter-chip" *ngIf="searchStartDisplay && searchEndDisplay">
            <span>Dates: {{ searchStartDisplay }} - {{ searchEndDisplay }}</span>
            <span class="close" (click)="removeFilter('date')">×</span>
          </div>
          <div class="filter-chip" *ngFor="let subId of selectedSubcategories">
            <span>{{ getSubcategoryName(subId) }}</span>
            <span class="close" (click)="removeFilter('subcategory', subId)">×</span>
          </div>
          <div class="filter-chip" *ngIf="selectedEmirate">
            <span>{{ selectedEmirate }}</span>
            <span class="close" (click)="removeFilter('emirate')">×</span>
          </div>
          <div class="filter-chip" *ngFor="let fuel of selectedFuels">
            <span>{{ fuel }}</span>
            <span class="close" (click)="removeFilter('fuel', fuel)">×</span>
          </div>
          <div class="filter-chip" *ngFor="let make of selectedMakes">
            <span>{{ make }}</span>
            <span class="close" (click)="removeFilter('make', make)">×</span>
          </div>
          <div class="filter-chip" *ngFor="let year of selectedYears">
            <span>YOM: {{ year }}</span>
            <span class="close" (click)="removeFilter('year', year)">×</span>
          </div>
          <button class="clear-all-pebble" (click)="clearAllFilters()">
            Clear All
          </button>
        </div>

        <!-- SUBCATEGORY HORIZONTAL SCROLL -->
        <div class="subcategory-container" *ngIf="subcategories.length || isLoading" [hidden]="isLoading">
          <div class="subcategory-scroll" #scrollArea [class.enable-scroll]="
              subcategories.length > 5 || (isLoading && !subcategories.length)
            " (scroll)="syncScrollBar(scrollArea)">
            <div class="subcategory-grid">
              <ng-container *ngIf="!isLoading; else subcatSkeleton">
                <div class="subcategory-card" *ngFor="let sub of subcategories"
                  [class.active]="pendingSubcategories.includes(sub.id)" (click)="toggleSubcategory(sub.id)">
                  <div class="subcategory-img">
                    <img [src]="sub.imageUrl" alt="{{ sub.name }}" (load)="onImageLoad()" (error)="onImageLoad()" />
                  </div>
                  <div class="subcategory-info">
                    <h4>{{ sub.name }}</h4>
                  </div>
                </div>
              </ng-container>
              <ng-template #subcatSkeleton>
                <div class="skeleton-subcat-card" *ngFor="let i of [1, 2, 3, 4, 5]">
                  <div class="skeleton skeleton-circle"></div>
                  <div class="skeleton skeleton-text"></div>
                  <div class="skeleton skeleton-text" style="width: 40%"></div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="subcategory-scrollbar" *ngIf="subcategories.length > 5" #scrollBarWrapper
            (mousedown)="startDrag($event, scrollArea, scrollBarWrapper)">
            <div #scrollThumb class="scrollbar-thumb"></div>
          </div>
        </div>

        <!-- MAIN EQUIPMENT GRID LOADING -->
        <ng-container *ngIf="isLoading">
          <section class="recommended-grid main-grid" style="margin-top: 25px">
            <div class="skeleton-card" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]">
              <div class="skeleton skeleton-img"></div>
              <div class="skeleton skeleton-line title"></div>
              <div class="skeleton skeleton-line subtitle"></div>
              <div class="skeleton skeleton-line price"></div>
            </div>
          </section>
        </ng-container>

        <!-- EQUIPMENT GRID -->
        <section *ngIf="filteredEquipment.length > 0; else noData" [hidden]="isLoading"
          class="recommended-grid main-grid">
          <div class="card1" *ngFor="let eq of filteredEquipment | slice:0:displayedCount"
            [class.selected-card]="showCompare && isInCompareList(eq)"
            [class.compare-limit-reached]="showCompare && isCompareMode && compareList.length >= 3 && !isInCompareList(eq)"
            [routerLink]="showCompare && isCompareMode ? null : ['/booking-detail', eq.id]" [style.cursor]="'pointer'">

            <!-- SELECTION BADGE — replaces checkbox, Airbnb-style top-right circle -->
            <div class="compare-select-badge" *ngIf="showCompare && isCompareMode"
              [class.is-selected]="isInCompareList(eq)" (click)="toggleCompare($event, eq)">
              <div class="badge-inner">
                <!-- Checkmark SVG, shown when selected -->
                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 5L5 8.5L11.5 1.5" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>

            <div class="image-box" (click)="showCompare && isCompareMode && toggleCompare($event, eq)">
              <div class="demo-badge-tag" *ngIf="eq.isDemo">
                <span class="demo-dot"></span> DEMO
              </div>
              <img *ngIf="eq.images && eq.images.length > 0; else noImage" [src]="eq.images[0]" (load)="onImageLoad()"
                (error)="onImageLoad()" />
            </div>

            <div class="details" (click)="showCompare && isCompareMode ? toggleCompare($event, eq) : null">
              <div class="rating">
                ⭐ {{ eq.avgRating || 0 }}
                <small>({{ eq.totalReviews || 0 }})</small>
              </div>
              <h4>{{ eq.listingName || eq.name }}</h4>
              <p>{{ eq.brand }}</p>
              <p>Year of Mfr : {{ eq.year_of_manufacture }}</p>
              <div class="equip-price">
                <span class="price-currency">AED</span>
                <span class="price-amount">{{ getRatePrice(eq) }}</span>
                <span class="price-period">{{ getRatePeriod(eq) }}</span>
              </div>
            </div>
          </div>
        </section>

        <!-- SHOW MORE BUTTON -->
        <div class="show-more-wrapper" *ngIf="filteredEquipment.length > 0 && hasMore && !isLoading">
          <button class="show-more-btn" (click)="loadMore()">
            Show More
            <span class="show-more-count">{{ filteredEquipment.length - displayedCount }} more</span>
          </button>
        </div>

        <ng-template #noData>
          <div class="no-results" *ngIf="!isLoading">
            <img src="assets/no-file-found.png" alt="No Equipments" />
            <h3>No Equipments Found</h3>
            <p>Try changing your filters or search inputs.</p>
          </div>
        </ng-template>

        <ng-template #noImage>
          <img src="assets/no-image-available.jpg" alt="No Image" />
        </ng-template>
      </main>
    </div>
  </div>

  <!-- RANDOM EQUIPMENTS -->
  <div class="recommended-section" *ngIf="showRecommended && !isLoading && filteredRandom.length">
    <div class="recommended-header">
      <h2>
        Recommended Equipments
        <span *ngIf="selectedEmirate">in {{ selectedEmirate }}</span>
      </h2>
      <span class="view-all">View All</span>
    </div>
    <div class="recommended-grid">
      <div class="card1" *ngFor="let eq of filteredRandom" [class.selected-card]="showCompare && isInCompareList(eq)"
        [class.compare-limit-reached]="showCompare && isCompareMode && compareList.length >= 3 && !isInCompareList(eq)"
        [routerLink]="showCompare && isCompareMode ? null : ['/booking-detail', eq.id]">
        <div class="compare-select-badge" *ngIf="showCompare && isCompareMode" [class.is-selected]="isInCompareList(eq)"
          (click)="toggleCompare($event, eq)">
          <div class="badge-inner">
            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 5L5 8.5L11.5 1.5" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="image-box">
          <div class="demo-badge-tag" *ngIf="eq.isDemo">
            <span class="demo-dot"></span> DEMO
          </div>
          <img *ngIf="eq.images && eq.images.length > 0; else noImage" [src]="eq.images[0]" />
        </div>
        <div class="details">
          <div class="rating">
            ⭐ {{ eq.avgRating || 0 }}
            <small>({{ eq.totalReviews || 0 }})</small>
          </div>
          <h4>{{ eq.listingName || eq.name }}</h4>
          <p>{{ eq.brand }}</p>
          <p>Year of Mfr : {{ eq.year }}</p>
          <div class="equip-price">
            <span class="price-currency">AED</span>
            <span class="price-amount">{{ getRatePrice(eq) }}</span>
            <span class="price-period">{{ getRatePeriod(eq) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BECOME VENDOR -->
  <section class="become_vendor">
    <h1>Want to become a vendor on Aluguloo?</h1>
    <button class="become_btn" (click)="openServiceOfferDialog()">Let's Connect</button>
  </section>

  <!-- MYNTRA STYLE MODAL OVERLAY -->
  <div class="full-screen-filter-overlay" *ngIf="isFuelModalOpen || isMakeModalOpen" (click)="closeFilterModals()">
    <div class="filter-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Select {{ isFuelModalOpen ? 'Fuel' : 'Brand' }}</h3>
        <button class="close-modal" (click)="closeFilterModals()">×</button>
      </div>
      <div class="modal-body">
        <div class="filter-grid-layout">
          <label *ngFor="let option of (isFuelModalOpen ? fuels : makes)">
            <input type="checkbox" [value]="option"
              (change)="toggleSelection(option, isFuelModalOpen ? 'fuel' : 'make')"
              [checked]="isFuelModalOpen ? pendingFuels.includes(option) : pendingMakes.includes(option)" />
            <span class="opt-name">{{ option }}</span>
            <span class="opt-count">({{ getOptionCount(option, isFuelModalOpen ? 'fuel' : 'make') }})</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- FLOATING COMPARE TRAY -->
  <div class="compare-tray" [class.show]="showCompare && compareList.length >= 2 && isCompareMode">
    <div class="tray-pill">
      <span class="selected-count">{{ compareList.length }} Selected</span>
      <div class="tray-thumbnails">
        <div class="tray-thumb" *ngFor="let eq of compareList">
          <img [src]="eq.images?.[0] || 'assets/no-image-available.jpg'" />
          <span class="remove-thumb" (click)="toggleCompare($event, eq)">×</span>
        </div>
      </div>
      <button class="compare-btn" (click)="openCompareModal()">
        Compare <span class="compare-arrow">→</span>
      </button>
    </div>
  </div>
  <!-- COMPARISON MODAL -->
  <div class="compare-modal-backdrop" *ngIf="showCompare && showCompareModal" (click)="closeCompareModal()"></div>
  <div class="compare-modal" *ngIf="showCompare && showCompareModal" [class.show]="showCompareModal">
    <div class="modal-header">
      <h2>Equipment Comparison</h2>
      <button class="close-modal" (click)="closeCompareModal()">×</button>
    </div>

    <div class="modal-body" [style.--cols-count]="compareList.length">
      <!-- AI Recommendation Banner -->
      <div class="ai-recommendation-banner" *ngIf="bestValueRecommendation">
        <span class="banner-badge">⭐ Recommended Choice</span>
        <span class="banner-text">
          We recommend <strong>{{ bestValueRecommendation.recommendedName }}</strong> ({{
          bestValueRecommendation.recommendedBrand }}). Reasons: {{ bestValueRecommendation.reasons.join(', ') }}.
        </span>
      </div>

      <!-- Comparison Table -->
      <div class="table-responsive">
        <table class="comparison-table">
          <thead>
            <tr>
              <th class="feature-col">Feature</th>
              <th *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId">
                <div class="th-card" [class.is-recommended]="eq.id === bestValueRecommendation?.recommendedId">
                  <div class="card-badge" *ngIf="eq.id === bestValueRecommendation?.recommendedId">Recommended</div>
                  <div class="card-img-wrapper">
                    <img [src]="eq.images?.[0] || 'assets/no-image-available.jpg'" />
                  </div>
                  <div class="card-details">
                    <h4>{{ eq.listingName || eq.name }}</h4>
                    <p class="brand">{{ eq.brand }}</p>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="feature-col">Daily Rate</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId"
                [class.highlight-green]="eq.dailyRate === getLowestValueInRow('dailyRate')">
                AED {{ eq.dailyRate || 'N/A' }}
                <span class="winner-star" *ngIf="eq.dailyRate === getLowestValueInRow('dailyRate')">⭐</span>
              </td>
            </tr>
            <tr>
              <td class="feature-col">Weekly Rate</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId"
                [class.highlight-green]="eq.weeklyRate && eq.weeklyRate === getLowestValueInRow('weeklyRate')">
                AED {{ eq.weeklyRate || 'N/A' }}
                <span class="winner-star"
                  *ngIf="eq.weeklyRate && eq.weeklyRate === getLowestValueInRow('weeklyRate')">⭐</span>
              </td>
            </tr>
            <tr>
              <td class="feature-col">Monthly Rate</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId"
                [class.highlight-green]="eq.monthlyRate && eq.monthlyRate === getLowestValueInRow('monthlyRate')">
                AED {{ eq.monthlyRate || 'N/A' }}
                <span class="winner-star"
                  *ngIf="eq.monthlyRate && eq.monthlyRate === getLowestValueInRow('monthlyRate')">⭐</span>
              </td>
            </tr>
            <tr>
              <td class="feature-col">Availability</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId">
                {{ eq.availability || 'Available' }}
              </td>
            </tr>
            <tr>
              <td class="feature-col">With Driver</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId">
                {{ eq.withDriver === 'Yes' || eq.withDriver === true ? 'Yes' : 'No' }}
              </td>
            </tr>
            <tr>
              <td class="feature-col">With Fuel</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId">
                {{ eq.withFuel === 'Yes' || eq.withFuel === true ? 'Yes' : 'No' }}
              </td>
            </tr>
            <tr>
              <td class="feature-col">Year of Mfr</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId"
                [class.highlight-green]="getYearVal(eq) > 0 && getYearVal(eq) === getHighestValueInRow('year')">
                {{ getYearVal(eq) || 'N/A' }}
                <span class="winner-star"
                  *ngIf="getYearVal(eq) > 0 && getYearVal(eq) === getHighestValueInRow('year')">⭐</span>
              </td>
            </tr>
            <tr>
              <td class="feature-col">Emirate</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId">
                {{ eq.emirate || 'N/A' }}
              </td>
            </tr>
            <tr>
              <td class="feature-col">Rating</td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId"
                [class.highlight-green]="(eq.avgRating || 0) > 0 && (eq.avgRating || 0) === getHighestValueInRow('avgRating')">
                ⭐ {{ eq.avgRating || 0 }} ({{ eq.totalReviews || 0 }})
                <span class="winner-star"
                  *ngIf="(eq.avgRating || 0) > 0 && (eq.avgRating || 0) === getHighestValueInRow('avgRating')">⭐</span>
              </td>
            </tr>
            <tr class="actions-row">
              <td class="feature-col"></td>
              <td *ngFor="let eq of compareList"
                [class.is-recommended-col]="eq.id === bestValueRecommendation?.recommendedId">
                <button class="view-listing-btn" [routerLink]="['/booking-detail', eq.id]"
                  (click)="closeCompareModal()">View Listing</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>